import { useState } from 'react'
import NewTable, { TableBodyData, TableHeaderColumn } from "components/NewTable";
import PageDefault from "components/PageDefault";
import { Button, Col, Modal, Spinner } from "react-bootstrap";
import { Row } from "react-bootstrap";
import NewForm from 'components/NewForm';
import extractFormData from 'utils/extractFormatData';
import Icon from 'components/Icon';
import { makeid } from 'utils/random';
import actionSubcategoryService from 'services/action.subcategory.service';


export default function Category() {  
  const [key, setKey] = useState<any>(makeid(5))
  const [showModal, setShowModal] = useState<boolean>(false)
  const [data, setData] = useState<any>({})
  const [isSaving, setIsSaving] = useState<boolean>(false)

  function handleClose() {
    setShowModal(false)
  }

  const handleSubmit = async () => {
    setIsSaving(true)
    let formData = new FormData()
    extractFormData(data, formData)

    var response;
    if (data.id)
      response = actionSubcategoryService.update(data.id, formData)
    else
      response = actionSubcategoryService.store(formData)

    response
      .then(() => {
        reload()
        handleClose()
      })
      .finally(() => setIsSaving(false))
  }

  const handleUpdate = (id: number) => {
    actionSubcategoryService.show(id)
      .then((data) => {
        const {id, name} = data
        setData({...data, ...{id, name}})
        setShowModal(true)
      })
  }

  const reload = () => {
    setKey(makeid(5))
  }

  return (
    <PageDefault title="Categorias">
      <PageDefault.Title>Categorias</PageDefault.Title>
      <PageDefault.Content>
        <Row className="mt-3 mb-3">
          <Col>
            <Button
              onClick={() => {
                setShowModal(true)
              }}
            >
              Criar Categoria
            </Button>
          </Col>
        </Row>
        <NewTable>
          <TableHeaderColumn dataField="id">ID</TableHeaderColumn>
          <TableHeaderColumn dataField="name">Categoria</TableHeaderColumn>
          <TableHeaderColumn dataField="id|" isAction mask={(v:any[])=>{
            const [id] = v;
            return (
              <>
                <Button size="sm" style={{margin:"0px 1px"}} onClick={() => handleUpdate(id)}><Icon name="edit"/></Button>
              </>
            );
          }}>Ação</TableHeaderColumn>
          <TableBodyData
            key={key}
            request={actionSubcategoryService} 
            filterDefaut={{
              order_column: '!id'
            }}
          />
        </NewTable>
      </PageDefault.Content>
      <Modal
        centered
        show={showModal}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <NewForm title='Criar Categoria'>
            <NewForm.Input title="Nome" md="12" name="name" state={{model: data, setModel: setData}}/>
          </NewForm>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button disabled={isSaving} variant="primary" onClick={() => handleSubmit()}>
            Salvar {isSaving ? <Spinner animation="border" size="sm" /> : (<></>)}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <SweetAlert2 {...swalProps} /> */}
    </PageDefault>
  )
}